import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.5 6.186v7.627a.6.6 0 0 1-.309.525l-6.9 3.833a.6.6 0 0 1-.582 0l-6.9-3.833a.6.6 0 0 1-.309-.525V6.186a.6.6 0 0 1 .309-.524l6.9-3.834a.6.6 0 0 1 .582 0l6.9 3.834a.6.6 0 0 1 .309.524"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m2.94 6.078 6.768 3.76a.6.6 0 0 0 .583 0l6.792-3.774M10 17.5V10"
    }, null, -1)
  ]))]))
}
export default { render: render }